import React from 'react';
import { ArrowRightIcon, CheckIcon, BookOpenIcon, MicIcon, CalendarIcon, LayersIcon } from 'lucide-react';
import { PageTransition } from '../../components/layout/PageTransition';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { DecorativeShape } from '../../components/DecorativeShape';
import { Animate } from '../../components/ui/Animate';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
export function MeetingsAndFacilitation() {
  const {
    t
  } = useLanguage();
  const signs = t('meetingsAndFacilitation.signs') as string[];
  const whatWeDoItems = t('meetingsAndFacilitation.whatWeDoItems') as string[];
  return <PageTransition data-id="element-1731" data-mp="cx5fhypai2gl">
      <div className="pt-12 pb-24" data-id="element-1732" data-mp="czrkbqksq3v4">
        {/* Hero */}
        <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1733" data-mp="hyb87wiy9pq4">
          <DecorativeShape type="blob" color="bg-yellow-200/40" className="top-0 right-0 w-[500px] h-[500px] translate-x-1/4 -translate-y-1/4 -z-10" data-id="element-1734" data-mp="lxtr6mr7nqqb" />
          <Animate className="max-w-3xl" data-id="element-1735" data-mp="rx1j51l3pewo">
            <span className="inline-block px-4 py-2 bg-yellow-100 text-yellow-700 font-medium rounded-full text-sm mb-6" data-id="element-1736" data-mp="rze1hfurtra9">
              {t('meetingsAndFacilitation.badge')}
            </span>
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-1737" data-mp="i0y7940g61wj">
              {t('meetingsAndFacilitation.title')}
              <br data-id="element-1738" data-mp="1ansols1ywl5s" />
              <span className="text-yellow-600" data-id="element-1739" data-mp="1an9akmffugx1">{t('meetingsAndFacilitation.titleHighlight')}</span>
            </h1>
            <p className="text-xl text-gray-600 mb-6 leading-relaxed" data-id="element-1740" data-mp="15w0zllygmnhr">
              {t('meetingsAndFacilitation.intro1')}
            </p>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-1741" data-mp="10vwqigzvsv1k">
              {t('meetingsAndFacilitation.intro2')}
            </p>
            <Link to="/contact" data-id="element-1742" data-mp="1tm4zpjcfw540">
              <Button size="lg" rightIcon={<ArrowRightIcon size={20} data-id="element-1744" data-mp="1tkk9g5x5r8by" />} data-id="element-1743" data-mp="1tlvcg3is4c20">
                {t('meetingsAndFacilitation.heroCta')}
              </Button>
            </Link>
          </Animate>
        </section>

        {/* Signs */}
        <section className="bg-cream py-20 mb-20" data-id="element-1745" data-mp="3svojeg3dl0xm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1746" data-mp="3e3o051pfrrwu">
            <Animate className="mb-12" data-id="element-1747" data-mp="3j3iqn45aufhd">
              <h2 className="text-3xl font-bold text-charcoal" data-id="element-1748" data-mp="3j2he0v8mxkxj">
                {t('meetingsAndFacilitation.signsTitle')}
              </h2>
            </Animate>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1749" data-mp="395cruveshpgq">
              {signs.map((sign, i) => <Animate key={i} delay={i * 0.05} data-id="element-1750" data-mp="2v6d3zpz3pelm" data-mpi={i}>
                  <div className="flex items-start gap-3 bg-white rounded-2xl p-5 shadow-sm" data-id="element-1751" data-mp="2v7xw78xy0lgb">
                    <div className="mt-0.5 p-1 rounded-full bg-yellow-100 text-yellow-600 flex-shrink-0" data-id="element-1752" data-mp="3056fjcutuvj5">
                      <CheckIcon size={14} strokeWidth={3} data-id="element-1753" data-mp="tcdpkvqomh4p" />
                    </div>
                    <span className="text-gray-700" data-id="element-1754" data-mp="ycrzykfra35w">{sign}</span>
                  </div>
                </Animate>)}
            </div>
          </div>
        </section>

        {/* What we work on */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1755" data-mp="2duej51v1o218">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-1756" data-mp="2smyhlp791lcc">
            <Animate data-id="element-1757" data-mp="2ntnjqdkf0ewk">
              <h2 className="text-3xl font-bold text-charcoal mb-6" data-id="element-1758" data-mp="2nt43r2ebs0l6">
                {t('meetingsAndFacilitation.whatWeDoTitle')}
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-1759" data-mp="2wn8wxsgxlo3v">
                {t('meetingsAndFacilitation.whatWeDoP1')}
              </p>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1760" data-mp="3bjrdlt7sx0ad">
                {t('meetingsAndFacilitation.whatWeDoP2')}
              </p>
            </Animate>
            <Animate delay={0.1} data-id="element-1761" data-mp="1h5gmtf7nbw1y">
              <div className="space-y-3" data-id="element-1762" data-mp="1h6rys2b8wa45">
                {whatWeDoItems.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-1763" data-mp="1c8q8oxfejaj6" data-mpi={i}>
                    <div className="mt-1 p-1 rounded-full bg-yellow-100 text-yellow-600 flex-shrink-0" data-id="element-1764" data-mp="3b05gxn07rgy">
                      <CheckIcon size={14} strokeWidth={3} data-id="element-1765" data-mp="88ie0mx404of" />
                    </div>
                    <span className="text-gray-700" data-id="element-1766" data-mp="d7v4rir3pvwa">{item}</span>
                  </div>)}
              </div>
            </Animate>
          </div>
        </section>

        {/* Ways to work together */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1767" data-mp="3gq663pgtnvww">
          <Animate className="mb-12" data-id="element-1768" data-mp="3lnoixqxymva6">
            <h2 className="text-3xl font-bold text-charcoal" data-id="element-1769" data-mp="3lopurxmsvlsy">
              {t('meetingsAndFacilitation.waysTitle')}
            </h2>
            <p className="text-gray-500 mt-2" data-id="element-1770" data-mp="3pnyncz63tdmx">{t('meetingsAndFacilitation.waysSubtitle')}</p>
          </Animate>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1771" data-mp="2xylvg2gna87r">
            {[{
            icon: <BookOpenIcon size={24} className="text-coral" data-id="element-1772" data-mp="31zfh0p6m7axh" />,
            typeBg: 'bg-coral/10 text-coral',
            typeKey: 'courseLabel',
            titleKey: 'course1Title',
            descKey: 'course1Desc',
            path: '/services/courses/better-online-meetings'
          }, {
            icon: <BookOpenIcon size={24} className="text-purple-600" data-id="element-1773" data-mp="2le6qm3n3g85h" />,
            typeBg: 'bg-purple-100 text-purple-700',
            typeKey: 'courseLabel',
            titleKey: 'course2Title',
            descKey: 'course2Desc',
            path: '/services/courses/better-online-workshops'
          }, {
            icon: <LayersIcon size={24} className="text-teal" data-id="element-1774" data-mp="21r91tsb337wk" />,
            typeBg: 'bg-teal/10 text-teal',
            typeKey: 'workshopLabel',
            titleKey: 'workshop1Title',
            descKey: 'workshop1Desc',
            path: '/services/workshops'
          }, {
            icon: <MicIcon size={24} className="text-yellow-600" data-id="element-1775" data-mp="1ntki4nsr66t3" />,
            typeBg: 'bg-yellow-100 text-yellow-700',
            typeKey: 'talkLabel',
            titleKey: 'talk1Title',
            descKey: 'talk1Desc',
            path: '/services/talks'
          }].map((item, i) => <Animate key={i} delay={i * 0.1} data-id="element-1776" data-mp="148kacfnutr6l" data-mpi={i}>
                <Card hoverEffect className="h-full p-6 flex flex-col" data-id="element-1777" data-mp="194r65fmjdmat">
                  <div className="flex items-center gap-3 mb-4" data-id="element-1778" data-mp="1wvepcx1wjyco">
                    {item.icon}
                    <span className={`text-xs font-bold px-3 py-1 rounded-full ${item.typeBg}`} data-id="element-1779" data-mp="21tyd93023k7o">
                      {t(`meetingsAndFacilitation.${item.typeKey}`)}
                    </span>
                  </div>
                  <h3 className="font-bold text-lg text-charcoal mb-2" data-id="element-1780" data-mp="1s3wlo18hvjo0">
                    {t(`meetingsAndFacilitation.${item.titleKey}`)}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed flex-1 mb-4" data-id="element-1781" data-mp="2fs64qvebptbg">
                    {t(`meetingsAndFacilitation.${item.descKey}`)}
                  </p>
                  <Link to={item.path} data-id="element-1782" data-mp="945u9cx51kvu">
                    <Button variant="outline" size="sm" rightIcon={<ArrowRightIcon size={16} data-id="element-1784" data-mp="45ukt3ar9ce5" />} data-id="element-1783" data-mp="46nh1ac38ji1">
                      {t('meetingsAndFacilitation.learnMore')}
                    </Button>
                  </Link>
                </Card>
              </Animate>)}
          </div>
        </section>

        {/* CTA */}
        <section className="max-w-4xl mx-auto px-4 text-center" data-id="element-1785" data-mp="3mbh0fjo1laik">
          <Animate data-id="element-1786" data-mp="3hd5pf5m0gtyr">
            <Card className="p-12 bg-gradient-to-br from-yellow-50 to-amber-50 border-0" data-id="element-1787" data-mp="3hdp7qnfkpkdb">
              <div className="w-16 h-16 mx-auto mb-6 bg-white rounded-full flex items-center justify-center shadow-md" data-id="element-1788" data-mp="3vcoyq1qk6bcn">
                <CalendarIcon size={32} className="text-yellow-600" data-id="element-1789" data-mp="3rb3luge0xx2g" />
              </div>
              <h2 className="text-3xl font-bold mb-4" data-id="element-1790" data-mp="1am6i725r6q8o">{t('meetingsAndFacilitation.ctaTitle')}</h2>
              <p className="text-gray-600 mb-8 max-w-xl mx-auto" data-id="element-1791" data-mp="16lnqr97rvm70">{t('meetingsAndFacilitation.ctaDesc')}</p>
              <Link to="/contact" data-id="element-1792" data-mp="304mopyqhjgmn">
                <Button variant="primary" rightIcon={<ArrowRightIcon size={18} data-id="element-1794" data-mp="352y04dwfhz6z" />} data-id="element-1793" data-mp="305ob2zcybpjo">
                  {t('meetingsAndFacilitation.ctaCta')}
                </Button>
              </Link>
            </Card>
          </Animate>
        </section>
      </div>
    </PageTransition>;
}